export const leadConfirmConstants = { 
  ACCESSIBILITY_CONFIRMED: 'ACCESSIBILITY_CONFIRMED',
  ADD_REPAIR: 'ADD_REPAIR',
  DELETE_REPAIR: 'DELETE_REPAIR',
  UPDATE_REPAIR: 'UPDATE_REPAIR',
  RESET_CONFIRMATIONS: 'RESET_CONFIRMATIONS'
}
